import { DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { RequestResponse } from "../model/dto/RequestResponse";
import { Observable } from "rxjs";
import { UnsoldItemSizeDto } from "../model/dto/UnsoldItemSizeDto";

@Injectable()
export class UnsoldItemSizeFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;
    private _datePipe: DatePipe;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string, datePipe: DatePipe) {
        this._urlBase = baseUrl;
        this._httpClient = http;
        this._datePipe = datePipe;
    }

    GetCollectionUnsoldItemSizeByOrganizationDates(organizations: string, startDate: string, endDate: string, language: number): Observable<RequestResponse<UnsoldItemSizeDto[]>> {
        return this._httpClient.get<RequestResponse<UnsoldItemSizeDto[]>>(this._urlBase + 'api/UnsoldItemSize/ByOrganizationDates?organizations='
         + organizations + '&startDate=' + startDate + '&endDate=' + endDate + '&language=' + language);
    }
}
